import { render, staticRenderFns } from "./HomeControls.vue?vue&type=template&id=3fb2ecb2&scoped=true"
import script from "./HomeControls.vue?vue&type=script&lang=ts"
export * from "./HomeControls.vue?vue&type=script&lang=ts"
import style0 from "./HomeControls.vue?vue&type=style&index=0&id=3fb2ecb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2ecb2",
  null
  
)

export default component.exports